(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/poker-react/components/upcoming-events/assets/javascripts/filter-modal.js') >= 0) return;  svs.modules.push('/modules/poker-react/components/upcoming-events/assets/javascripts/filter-modal.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useState = _React.useState;
const Modal = svs.components.lbUi.modal.Modal;
const _svs$ui = svs.ui,
  Button = _svs$ui.ReactButton,
  Icon = _svs$ui.ReactIcon;
const _svs$poker_react$comp = svs.poker_react.components.upcomingEvents,
  BuyinFilter = _svs$poker_react$comp.BuyinFilter,
  GameTypeFilter = _svs$poker_react$comp.GameTypeFilter,
  TournamentTypeFilter = _svs$poker_react$comp.TournamentTypeFilter,
  SatelliteFilter = _svs$poker_react$comp.SatelliteFilter;
const actionTypes = svs.poker_react.components.upcomingEvents.filterReducer.actionTypes;
const FilterModal = _ref => {
  let activeFilters = _ref.activeFilters,
    dispatch = _ref.dispatch,
    isPokerSM = _ref.isPokerSM;
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showModal = _useState2[0],
    setShowModal = _useState2[1];
  const renderFilters = () => {
    if (isPokerSM) {
      return React.createElement(SatelliteFilter, {
        activeSatelliteFilter: activeFilters.satellite,
        setActiveSatelliteFilter: filter => dispatch({
          type: actionTypes.SET_SATELLITE_FILTER,
          payload: filter
        })
      });
    }
    return React.createElement(React.Fragment, null, React.createElement(GameTypeFilter, {
      activeGameTypeFilter: activeFilters.gameType,
      setActiveGameTypeFilter: filter => dispatch({
        type: actionTypes.SET_GAME_TYPE_FILTER,
        payload: filter
      })
    }), React.createElement(BuyinFilter, {
      activeBuyinFilter: activeFilters.buyin,
      isNetwork: activeFilters.tournamentType === 'network',
      setActiveBuyinFilter: filter => dispatch({
        type: actionTypes.SET_BUY_IN_FILTER,
        payload: filter
      })
    }));
  };
  return React.createElement(React.Fragment, null, React.createElement(Button, {
    block: true,
    className: "btn-mobile-filter",
    iconPosition: "center",
    onClick: () => setShowModal(true)
  }, React.createElement(Icon, {
    icon: "filter"
  }), React.createElement("span", {
    className: "btn-text"
  }, "Filter")), React.createElement(Modal, {
    className: "mobile-filter-container",
    isOpen: showModal
  }, React.createElement("div", {
    className: "mobile-filter-controls"
  }, React.createElement("fieldset", null, React.createElement("legend", {
    className: "f-content f-center h2 fc-white margin-bottom-2"
  }, "Filter"), React.createElement(TournamentTypeFilter, {
    activeTournamentFilter: activeFilters.tournamentType,
    setTournamentFilter: filter => dispatch({
      type: actionTypes.SET_TOURNAMENT_FILTER,
      payload: filter.id
    })
  }), renderFilters())), React.createElement(Button, {
    className: "btn-mobile-filter-close btn-poker",
    onClick: () => setShowModal(false)
  }, "Klar")));
};
setGlobal('svs.poker_react.components.upcomingEvents.FilterModal', FilterModal);

 })(window);